import { SCROLLABLE_LIST_ROW_HEIGHT } from '@components'

import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BillsListItemSkeletonWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: ${SCROLLABLE_LIST_ROW_HEIGHT}px;
  margin-top: -${Spacing.S2};
  padding: 0 ${Spacing.S24} 0 ${Spacing.S16};
  border-bottom: 1px solid ${Color.Grey150};
`

export const SubjectsListItemContentSkeletonWrapper = styled.div`
  width: 100%;
`

export const DetailsSkeletonWrapper = styled.div`
  display: grid;
  grid-template-columns: 120px 70px 300px;
`
